import { useTranslation } from 'react-i18next';
import { SearchX, Plus, Lightbulb } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';

interface SignalEmptyStateProps {
  type: 'no-results' | 'no-signals';
  onAddSignal?: () => void;
}

export const SignalEmptyState = ({
  type,
  onAddSignal,
}: SignalEmptyStateProps) => {
  const { t } = useTranslation('knowledge');

  if (type === 'no-results') {
    return (
      <div className="pointer-events-none absolute inset-x-0 top-0 bottom-0 flex flex-col items-center justify-center text-center">
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-xl bg-white">
          <SearchX className="h-8 w-8 text-[#b0a89e]" />
        </div>
        <h3 className="mb-2 text-[15px] font-semibold text-[#5c554d]">
          {t('noSignalsFound')}
        </h3>
        <p className="text-[13px] text-[#8c8078]">
          {t('noSignalsFoundDescription')}
        </p>
      </div>
    );
  }

  return (
    <div className="py-16 text-center">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-xl bg-[#f0ece6]">
        <Lightbulb className="h-8 w-8 text-[#b0a89e]" />
      </div>
      <h3 className="mb-2 text-[15px] font-semibold text-[#5c554d]">
        {t('noSignalsYet')}
      </h3>
      <p className="mx-auto mb-6 max-w-md text-[13px] text-[#8c8078]">
        {t('noSignalsYetDescription')}
      </p>
      {onAddSignal && (
        <Button
          className="mx-auto flex items-center gap-2 bg-[#7c6bc4] hover:bg-[#6a5aae]"
          onClick={onAddSignal}
        >
          <Plus className="h-4 w-4" />
          {t('addYourFirstSignal')}
        </Button>
      )}
    </div>
  );
};
